import { render } from "./bmdetail.vue?vue&type=template&id=083fa852&scoped=true"
import script from "./bmdetail.vue?vue&type=script&lang=js"
export * from "./bmdetail.vue?vue&type=script&lang=js"

import "./bmdetail.vue?vue&type=style&index=0&id=083fa852&lang=scss&scoped=true"
import "./bmdetail.vue?vue&type=style&index=1&id=083fa852&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083fa852"]])

export default __exports__